import React from 'react';
import { Package, Gift } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { tools, bonuses } from '../../data/content';
export function IncludesSection() {
  return <section className="bg-white py-16 md:py-[84px]" data-id="element-108" data-mp="277i26x0q70xd">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-109" data-mp="2c4rxuuepk8tn">
        <SectionHeading kicker="Qué incluye" icon={Package} title={<>
              Todo lo que recibes <em data-id="element-111" data-mp="34tfe2bklo80c">hoy mismo</em>
            </>} lead="6 herramientas + 3 bonos. Más de 80 recursos listos para usar." data-id="element-110" data-mp="2c5b6tlmdrmvj" />
        <div className="mt-11 grid gap-5 md:grid-cols-2" data-id="element-112" data-mp="2pvn0vq2izvpb">
          {tools.map(({
          icon: Icon,
          label,
          title,
          description,
          formats
        }) => <Reveal key={title} className="flex flex-col rounded-3xl border border-line bg-white p-[22px] shadow-card md:p-7" data-id="element-113" data-mp="2uxcendh4unh3">
              <span className="inline-flex w-fit items-center gap-2 rounded-full bg-tangerine px-[13px] py-1.5 font-display text-[12.5px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-114" data-mp="1jhxgi6d6tpke">
                <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-115" data-mp="1c2cl6qiddtyw" />
                {label}
              </span>
              <h3 className="mt-3 text-[23px] font-bold leading-[1.15] text-forest md:text-[28px]" data-id="element-116" data-mp="1q2dkw2mwevcs">{title}</h3>
              <p className="mt-2.5 leading-relaxed text-muted" data-id="element-117" data-mp="1l3u1a8vs1vnl">{description}</p>
              <ul className="mt-auto flex flex-wrap gap-2 pt-4" data-id="element-118" data-mp="1zxfcd54nc9ij">
                {formats.map(f => <li key={f} className="rounded-full border border-line bg-cream px-[11px] py-[5px] font-display text-[12.5px] font-bold text-forest" data-id="element-119" data-mp="1uzds4gvhi45h">
                    {f}
                  </li>)}
              </ul>
            </Reveal>)}
        </div>

        <Reveal className="mt-14 text-center" data-id="element-120" data-mp="2dqn5504grb1t">
          <p className="inline-flex items-center gap-2 font-display text-[13px] font-bold uppercase tracking-[0.14em] text-tangerine" data-id="element-121" data-mp="2drpxlchfplju">
            <Gift className="h-4 w-4" aria-hidden="true" data-id="element-122" data-mp="1bb5t529gzz7z" />Y además, de regalo
          </p>
        </Reveal>
        <div className="mt-5 grid gap-[18px] md:grid-cols-3" data-id="element-123" data-mp="1kdnhbm8or1xm">
          {bonuses.map((b, i) => <Reveal key={b.tag} delay={i * 0.05} className="flex flex-col overflow-hidden rounded-[22px] bg-forest text-cream" data-id="element-124" data-mp="1p4dliw5dkyqq" data-mpi={i}>
              <img src={b.image} alt={`Portada del bono: ${b.title}`} className="aspect-square w-full object-cover" width={512} height={512} loading="lazy" data-id="element-125" data-mp="1u49n6oqloe34" />
              <div className="flex flex-1 flex-col p-6" data-id="element-126" data-mp="2839c7xi0yuzt">
                <p className="font-display text-[13px] font-extrabold uppercase tracking-[0.12em] text-tangerine-light" data-id="element-127" data-mp="282pv2j078amu">
                  {b.tag} · De regalo
                </p>
                <h4 className="mb-1.5 mt-2 text-[19px] font-semibold leading-snug" data-id="element-128" data-mp="dq9sbs6m3emq">{b.title}</h4>
                <p className="text-[14.5px] leading-relaxed text-forest-soft" data-id="element-129" data-mp="66r2p32v4n56">{b.text}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}